<template>
  <v-layout column >
    <v-flex class="flexBasis" md6 style="overflow: hidden">
      <v-row>
        <v-col
          cols="12"
          class="text-right"
        >
          <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
            <v-icon dark>mdi-check</v-icon>Save
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers='headers'
        :items='adoptions'
        v-model='selected'
        :single-select='singleSelect'
        item-key='code'
        show-select
        hide-default-footer
        :disable-pagination="true"
      >
        <template v-slot:item.bookTitleYear="{ item }">
          <span v-if="typeof item.title !== 'undefined' && item.title !== ''">{{ item.title }}</span>
          <span v-else >{{ item.code }}</span>
        </template>
        <template v-slot:no-data>
          <p>{{NO_DATA_FOUND}}</p>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  name: 'AdminStateLocalAdoption',
  data: () => ({
    btnLoader: false,
    selected: [],
    singleSelect: false,
    localAdoptionList: [],
    TABLE_TITLE: CONSTANTS.LOCAL_ADOPTION_LISTING_PAGE,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    I_CODE_LIST: CONSTANTS.I_CODES_FOR_LOCAL_ADOPTION,
    headers: [
      {
        text: 'I-Code Title',
        value: 'bookTitleYear',
        sortable: false,
        class: 'subtitle-2'
      }
    ]
  }),
  props: {
    adoptionLevelFor: {
      Type: String
    },
    adoptionLevel: {
      Type: Number
    },
    name: {
      Type: String
    }
  },
  mounted () {
    let adoptionLevel = this.adoptionLevel
    let adoptionLevelFor = this.adoptionLvlFor
    let adoptionName = this.adoptionName
    this.$store.commit('AdoptionModule/setAdoptionData', { adoptionLevel, adoptionLevelFor, adoptionName })
    this.initialize()
  },
  computed: {
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    // to fetch adoption list
    adoptions () {
      return this.I_CODE_LIST
    },
    adoptionLvlFor () {
      return this.adoptionLevelFor
    },
    id () {
      return this.adoptionLevel
    },
    adoptionName () {
      return this.name
    }
  },
  methods: {
    save () {
      let id = []
      this.selected.map(item => {
        id.push(item.code)
      })
      if (this.adoptionLevelFor === '') {
        return
      }
      const formData = {
        id: id,
        adoptionLevelFor: this.adoptionLevelFor,
        userId: this.userId
      }
      new Promise((resolve, reject) => {
        this.btnLoader = true
        this.$store.dispatch('StateModule/addLocalStateAdoption', { resolve, reject, formData })
      })
        .then(responseData => {
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
        .catch(response => {
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
        .finally(() => {
          this.btnLoader = false
        })
    },
    initialize: function () {
      let idToGetInfo = this.$globalFromValidation.paramIsInNumFormat(this.$route.params.id)
      let userId = this.userId
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getLocalICodeAdoptionById', { resolve, reject, idToGetInfo, userId })
      })
        .then(responseData => {
          let currentCodes = []
          if (typeof (responseData) !== 'undefined') {
            responseData.forEach(function (arrayItem) {
              currentCodes.push({
                'code': arrayItem.icodeAbbreviation
              })
            })
          }
          this.selected = currentCodes
        })
        .catch(response => {
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
        .finally(() => {
        })
    },
    bulkEditUrl (id, adoptionLevel) {
      this.$router.push({ name: 'BulkAdoption', params: { adoptionLevel: CONSTANTS.BULK_ADOPTION_URL[adoptionLevel], id: id } })
    }
  }
}
</script>
